import { IModuleProps } from '../../core/utils/modules';
import SchachermayerAttachmentLabel from './components/SchachermayerAttachmentLabel';

export default {
    name: 'schachermayer',
    components: {
        AttachmentLabel: [
            {
                condition: ({ upfrontClassification }) => upfrontClassification === false,
                component: SchachermayerAttachmentLabel,
            },
        ],
    },
} as IModuleProps;
